export const useFederatedParams = () => {

    const params = new URLSearchParams(
        window.location.hash.split('?')[1] ?? ''
    );
    return {
        institution: params.get('institution'),
        token: params.get('token'),
    };
};